import './ErrorBoundary.scss';

import { Component, type ErrorInfo } from 'react';
import type { TErrorBoundaryProps, TErrorBoundaryState } from '../../utils/types';

import { useTranslation } from '../../utils';

function ErrorFallback() {
  const { t } = useTranslation();

  return (
    <div className='errorFallback'>
      <div className='errorFallback__card'>
        <svg width='40' height='40' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
          <circle cx='12' cy='12' r='9' />
          <path d='M12 8v5' strokeLinecap='round' strokeLinejoin='round' />
          <path d='M12 16h.01' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
        <h1>{t('Web.Title_something_went_wrong')}</h1>
        <p>{t('Web.Error_unexpected_app_error')}</p>
        <button type='button' onClick={() => window.location.reload()}>
          {t('Web.Text_reload_page')}
        </button>
      </div>
    </div>
  );
}

class ErrorBoundary extends Component<TErrorBoundaryProps, TErrorBoundaryState> {
  constructor(props: TErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): TErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Uncaught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
